import { boot } from 'quasar/wrappers'
import LogRocket from 'logrocket'

export default boot(() => {
  if (!process.env.DEV) {
    LogRocket.init('uotsmx/wg')
    LogRocket.identify(`${process.env.LOG_ROCKET}`, {
      email: 'signonglass@vonex.com.au'
    })
  }
})
